export default __webpack_public_path__ + "static/media/home_selected.e54ff163.svg";